module.exports = __webpack_public_path__ + "static/media/chat.9ec6b226.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chat.svg
// module id = 549
// module chunks = 0